import type { CSSProperties, FC, ReactNode } from 'react'
import type { Photograph } from '@/content/photographs'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface PhotoProps {
    photo: Photograph
    sizes: string
    fill?: boolean
    preload?: boolean
    className?: string
    style?: CSSProperties
}

export const Photo: FC<PhotoProps> = ({
    photo,
    sizes,
    fill = false,
    preload = false,
    className,
    style
}): ReactNode => {
    if (fill) {
        return (
            <Image
                src={photo.image}
                alt={photo.alt}
                fill
                sizes={sizes}
                preload={preload}
                placeholder='blur'
                draggable={false}
                className={cn('object-cover', className)}
                style={{ objectPosition: photo.focus ?? '50% 50%', ...style }}
            />
        )
    }

    return (
        <Image
            src={photo.image}
            alt={photo.alt}
            sizes={sizes}
            preload={preload}
            placeholder='blur'
            draggable={false}
            className={cn('block h-auto w-full', className)}
            style={style}
        />
    )
}
